<template>
  <!-- -->
  <div class="defaultViewStyle">
    <el-tabs v-model="activeName">
      <el-tab-pane label="按方案模板" name="solution" lazy>
        <solution-template-list/>
      </el-tab-pane>
      <el-tab-pane label="按客户" name="customer" lazy>
        <solution-customer-list/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import SolutionTemplateList from "@/views/h5/ai/solution/SolutionTemplateList.vue";
import SolutionCustomerList from "@/views/h5/ai/solution/SolutionCustomerList.vue";
import Util from "@/util/util";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    SolutionTemplateList, SolutionCustomerList
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  data() {
    return {
      activeName: "solution",
    };
  },
  created() {
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tabs";
</style>